import { createStore } from 'vuex';
import axios from 'axios';
import i18n from '@/i18n/index';
import router from '@/router/index';
import VueCookies from 'js-cookie';
import createPersistedState from 'vuex-persistedstate';

const VALID_STATUS_CODE = [200, 201, 202, 203, 204, 205, 206, 207, 208, 226]
const SECURE_COOKIE = process.env.VUE_APP_SECURE_COOKIE || true
const SAME_SITE = process.env.VUE_APP_SAME_SITE || 'lax'
import { useToast } from "vue-toastification";
const toast = useToast();

function initialState() {
	return {
		// projName: process.env.VUE_APP_PROJECT_DIR || 'MAPRAL',
		packageVersion: process.env.PACKAGE_VERSION || 0,
		buildDate: process.env.BUILD_DATE || Date.now(),
		buildEnv: process.env.NODE_ENV || 'development',
		language: process.env.VUE_APP_I18N_LOCALE || 'fr',
		loggedIn: false,
		uid: '',
		username: '',
		accessToken: '',
		refreshToken: '',
		roles: '',
		prsInfo: { prsStore: '', prsId: '', prsInitial: '', prsName: '' },
		hasError: false,
		flash: { status: null, msg: null },
		loading: false,
		loadingMsg: '',
		appConfig: {chartList: process.env.VUE_APP_CHART_LIST, defaultChart: process.env.VUE_APP_DEFAULT_CHART,  dateLongFormat: process.env.VUE_APP_DATE_LONG_FORMAT, dateShortFormat: process.env.VUE_APP_DATE_SHORT_FORMAT, sideNavInfoTop: process.env.VUE_APP_SIDENAV_INFO_TOP , sideNavInfoBot: process.env.VUE_APP_SIDENAV_INFO_BOT}
	};
}
function errorResponse(err) {
	if (err.response) {
		if (err.response.status == 401){
			console.log('Unauthorized');
			// !router.hasRoute('home') && !router.hasRoute('login') && 
			// if((context.getters.loggedIn == false || context.getters.accessToken == null) )
			// console.log('router === ', router.currentRoute.value.name)
			if(router.currentRoute.value.name == 'login')
				router.push({name: 'login'});
			else
				router.push({name: 'logout'});
		}
		else if (err.response.status == 403)
			console.log('Forbidden');
		else
			console.log('Status: ' + err.response.status);
	}
	else
		console.log(err.message);
		//console.log('An error occurred when trying to login');
}
const store = createStore({
	state : initialState,
	
	plugins: [
		createPersistedState({
			storage: {
				getItem: (key) => VueCookies.get(key),
				setItem: (key, value) => VueCookies.set(key, value, {
					secure: SECURE_COOKIE,
					sameSite: SAME_SITE,
					// expires: EXPIRY,
					// httpOnly: HTTP_ONLY
				}),
				removeItem: (key) => VueCookies.remove(key),
			},
			// , 'appConfig'
			paths: ['uid', 'accessToken', 'refreshToken', 'username', 'roles', 'prsInfo', 'loggedIn', 'language'],
		}),
	],
	getters: {
		appConfig(state) {
			return state.appConfig;
		},
		appVersion(state) {
			return state.packageVersion
		},
		appBuildDate(state) {
			return state.buildDate
		},
		appBuildEnv(state) {
			return state.buildEnv
		},
		formatDate(state) {
			return state.appConfig.dateLongFormat
		},
		formatDateShort(state) {
			return state.appConfig.dateShortFormat
		},
		language(state) {
			return state.language
		},
		loggedIn(state) {
			return state.loggedIn
			// return state.accessToken ? state.accessToken !== ''
			// return state.accessToken ? state.accessToken !== '' && state.validOtpCode : false;
		},
		uid(state) {
			return state.uid;
		},
		username(state) {
			return state.username;
		},
		accessToken(state) {
			return state.accessToken;
		},
		refreshToken(state) {
			return state.refreshToken;
		},
		roles(state) {
			return state.roles;
		},
		prsInfo(state) {
			return state.prsInfo;
		},
		isAuthorized: (state) => (roles) => {
			return roles.some(r => state.roles? state.roles.includes(r) : [].includes(r))
		},
		hasError(state) {
			return state.hasError;
		},
		getErrorMsgFormatted: (state) => (error) => {
			let msgError = '';
			if (error.response) {
				if (error.response.data.message){
					msgError = msgError + " <li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>"+error.response.data.message + "</li>"
				} 
				else if (error.response.data.errors) {
					let i = 0
					for (i; i < error.response.data.errors.length; i++) {
						msgError = msgError + "<li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>" + error.response.data.errors[i].message + "</li>"
					}
				} 
				else if (error.response.data._embedded && error.response.data._embedded.errors) {
					let i = 0
					for (i; i < error.response.data._embedded.errors.length; i++) {
						msgError = msgError + "<li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>" + error.response.data._embedded.errors[i].message + "</li>"
					}
				} 
				else if (error.response.data)
					msgError = error.response.data
			} 
			else if (error.data) {
				if (error.data.message){
					msgError = msgError + " <li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>"+error.data.message + "</li>"
				} 
				else if (error.data.errors) {
					let i = 0
					for (i; i < error.data.errors.length; i++) {
						msgError = msgError + "<li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>" + error.data.errors[i].message + "</li>"
					}
				} 
				else if (error.data._embedded && error.data._embedded.errors) {
					let i = 0
					for (i; i < error.data._embedded.errors.length; i++) {
						msgError = msgError + "<li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>" + error.data._embedded.errors[i].message + "</li>"
					}
				} 
				else if (error.data)
					msgError = error.data
			} 
			else
				msgError = error;
			let newFlash = { status: error.status, msg: msgError }
			state.flash = newFlash
			return msgError
		},
		flash(state) {
			return state.flash;
		},
		formatNumber: (state) => (number) => {
			var formatter = new Intl.NumberFormat(state.language, {});
			return formatter.format(number)
		},
		formatAmount: (state) => (amount) => {
			let codeCurrency = "XOF"
			var formatter = new Intl.NumberFormat(state.language, {
				style: 'currency',
				currency: codeCurrency,
				//minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
				maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
			});
			return formatter.format(amount)?.replaceAll(' ', ' ')
		},
		loading(state) {
			return state.loading;
		},
		loadingMsg(state) {
			return state.loadingMsg;
		},
		
	},
	mutations: {
		resetState(state) {
			const s = initialState();
			Object.keys(s).forEach((key) => {
				if (key !== 'language') {
					if (key !== 'mfaEnabled')
						state[key] = s[key];
				} 
				else
					state[key] = i18n.locale;
			});
		},
		setAppConfig(state, appConfig) {
			state.appConfig = appConfig;
		},
		setLanguage(state, lang) {
			state.language = lang;
		},
		login(state, accessToken) {
			state.uid = accessToken.uid;
			state.accessToken = accessToken.accessToken;
			state.refreshToken = accessToken.refreshToken;
			state.username = accessToken.username;
			state.roles = accessToken.roles;
			state.loggedIn = true;
		},
		logout(state) {
			state.uid = null;
			state.accessToken = null;
			state.refreshToken = null;
			state.username = null;
			state.roles = null;
			state.loggedIn = false;
			state.prsInfo = { prsStore: null, prsId: '', prsInitial: '', prsName: '' };
		},
		prsInfo(state, prsInfo) {
			state.prsInfo = prsInfo;
		},
		validateToken(state) {
			state.validToken = true;
		},
		invalidateToken(state) {
			state.validToken = false;
		},
		updateToken(state, newToken) {
			state.accessToken = newToken
		},
		validateSession(state) {
			state.validSession = true;
		},
		invalidateSession(state) {
			state.validSession = false;
		},
		hasError(state, status) {
			state.hasError = !VALID_STATUS_CODE.includes(status);
		},
		initFlash(state) {
			state.flash = { status: null, msg: null };
		},
		setFlash(state, newFlash) {
			state.flash = newFlash;
		},
		loading(state, msg) {
			state.loading = true;
			state.loadingMsg = msg;
		},
		unloading(state) {
			state.loading = false;
		},
		
	},
	actions: {
		setAppConfig(context, payload) {
			context.commit('setAppConfig', payload)
		},
		updateLanguage(context, language) {
			i18n.locale = language
			context.commit('setLanguage', language)
		},
		auth(){
			router.push({name: 'login'});
		},
		login(context, credentials) {
			return new Promise((resolve, reject) => {
				axios.post( (window.VUE_APP_REMOTE_API_URL   || process.env.VUE_APP_REMOTE_API_URL) + '/api/login',
					{username: credentials.username,password: credentials.password,},
					{headers: {'Content-Type': 'application/json; charset=UTF-8',}, }
				)
				.then((res) => {
					// console.log(res)
					if (res.data) {
						context.commit('login', res.data);
						/*if(res.data.mfaEnabled)
							context.commit('isValidOtpCode', false)
						else
							context.commit('isValidOtpCode', true)*/

						// NEW for prsStore
						try {
							if(res.data && res.data.uid) {
								var headers = {
									'X-Auth-Token': context.getters.accessToken,
									'accept':'application/json'
								}
								let urlParams = (window.VUE_APP_REMOTE_API_URL   || process.env.VUE_APP_REMOTE_API_URL) + '/api';
								urlParams += '/user/' + res.data.uid +'?format=json'
								axios.get(urlParams, {crossDomain: true,responseType: 'json', headers} )
								.then(response => {
									// console.log(response)
									let info = { prsStore: null, prsId:'', prsInitial: '', prsName: '' };
									if(response.data && response.data.prsPerson && response.data.prsPerson.prsStore)
										info.prsStore = response.data.prsPerson.prsStore.id
									if(response.data && response.data.prsPerson && response.data.prsPerson.firstName  && response.data.prsPerson.lastName){
										let initial = response.data.prsPerson.firstName.substring(0, 1).toUpperCase()
										initial = initial + response.data.prsPerson.lastName.substring(0, 1).toUpperCase()
										info.prsId = response.data.prsPerson.id.toString()
										info.prsInitial = initial
										info.prsName = response.data.prsPerson.prsPersonLib
										context.commit('prsInfo', info);
									}
									
								})
								.catch(error => {
									console.log(error)
								})
							}
						}
						catch (e) {
							console.log(e)
						}
						// FIN - NEW for prsStore

					}
					resolve(res);
				})
				.catch((err) => {
					context.commit('resetState');
					context.commit('login', {
						uid: null,
						username: null,
						accessToken: null,
						refreshToken: null,
						roles: null
					});
					errorResponse(err);
					reject(err);
				});
			});
		},
		refreshToken(context) {
			console.log('refreshing ......')
			return new Promise((resolve, reject) => {
				// api/oauth/access_token
				axios.post(
					(window.VUE_APP_REMOTE_API_URL || process.env.VUE_APP_REMOTE_API_URL) + 'api/oauth/access_token',
					new URLSearchParams({
						grant_type: 'refresh_token',
						refresh_token: context.getters.refreshToken,
					}),
					{
						crossDomain: true,
						responseType: 'json',
						headers: {
							'X-Auth-Token': context.getters.accessToken,
							'Content-Type': 'application/x-www-form-urlencoded',
						},
					}
				)
				.then((res) => {
					if (res.data) {
						const result = res.data;
						// console.log('User is re-connected');
						context.commit('login', result);
						resolve(res);
					} 
					else
						reject(res);
				})
				.catch((err) => {
					context.commit('resetState');
					context.commit('login', {
						uid: null,
						username: null,
						accessToken: null,
						refreshToken: null,
						roles: null,
					});
					errorResponse(err);
					reject(err);
				});
			});
		},
		logout(context) {
			return new Promise((resolve) => {
				context.commit('resetState');
				context.commit('logout');
				axios.defaults.headers.common['X-Auth-Token'] = null;
				resolve();
			});
		},
		axiosGet(context, payload) {
			var headers = {
				'X-Auth-Token': context.getters.accessToken,
				// 'Access-Control-Allow-Origin': '*',
				'accept':payload.accept ? payload.accept : 'application/json'
				// 'accept': 'application/json', 'application/pdf'
			}
			if(payload.group && payload.group === 'public')
				headers = {'accept': 'application/json'}

			// NEW 
			let urlParams = (window.VUE_APP_REMOTE_API_URL   || process.env.VUE_APP_REMOTE_API_URL) + '/' + (payload.group ? payload.group : 'api');
			
			if(payload.domain != null && payload.data != null )
				urlParams += '/' + payload.domain + '/paginate?format=json&'+new URLSearchParams(payload.data).toString()
			else if(payload.domain != null && payload.id != null )
				urlParams += '/' + payload.domain + '/' + payload.id +'?format=json'
			else if(payload.domain != null )
				urlParams += '/' + payload.domain + '?format=json&max=100'
			else if(payload.url != null ) //PlainUrl
				urlParams =  (window.VUE_APP_REMOTE_API_URL   || process.env.VUE_APP_REMOTE_API_URL) + payload.url + (payload.url.indexOf('?')>0? '&':'?') + "format=json"


			urlParams += '&lang='+context.getters.language

			return new Promise((resolve, reject) => {
				axios.get(urlParams,
					{
						crossDomain: true,
						// responseType: 'json',
						// responseType: 'json', 'blob', arraybuffer'
						responseType: payload.strResponseType ? payload.strResponseType : 'json',
						headers,
					}
				)
				.then((res) => {
					resolve(res);
					store.commit('hasError', 200);
				})
				.catch((err) => {
					errorResponse(err);
					reject(err);
				});
			});
		},
		axiosPut(context, payload) {
			var headers = {
				'X-Auth-Token': context.getters.accessToken,
				'accept': 'application/json'
			}
			if(payload.group && payload.group === 'public')
				headers = {'accept': 'application/json'}

			// NEW 
			let urlParams = (window.VUE_APP_REMOTE_API_URL   || process.env.VUE_APP_REMOTE_API_URL) + '/' + (payload.group ? payload.group : 'api');
			
			if(payload.domain != null && payload.id != null )
				urlParams += '/' + payload.domain + '/' + payload.id +'?format=json&lang='+context.getters.language
			else if(payload.url != null ) //PlainUrl
				urlParams =  (window.VUE_APP_REMOTE_API_URL   || process.env.VUE_APP_REMOTE_API_URL) + payload.url

			return new Promise((resolve, reject) => {
				axios.put(urlParams,
						payload.data, {
							crossDomain: true,
							responseType: payload.strResponseType ? payload.strResponseType : 'json',
							// responseType: 'json', //json
							headers,
						}
					)
					.then((res) => {
						// console.log('res  store == ', res)
						// return res
						resolve(res);
					})
					.catch((err) => {
						errorResponse(err);
						reject(err);
					});
			});
		},
		axiosPost(context, payload) {
			var headers = {
				'X-Auth-Token': context.getters.accessToken,
				'accept': payload.accept ? payload.accept : 'application/json'
			}
			if(payload.group && payload.group === 'public')
				headers = {'accept': 'application/json'}

			// NEW 
			let urlParams = (window.VUE_APP_REMOTE_API_URL   || process.env.VUE_APP_REMOTE_API_URL) + '/' + (payload.group ? payload.group : 'api');
			
			if(payload.domain != null  )
				urlParams += '/' + payload.domain +'?format=json&lang='+context.getters.language
			else if(payload.url != null ) //PlainUrl
				urlParams =  (window.VUE_APP_REMOTE_API_URL   || process.env.VUE_APP_REMOTE_API_URL) + payload.url

			return new Promise((resolve, reject) => {
				axios.post(urlParams,
					payload.data, {
						crossDomain: true,
						responseType: payload.strResponseType ? payload.strResponseType : 'json',
						// responseType: payload.responseType ? payload.responseType : 'json', // blob
						headers,
					}
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					errorResponse(err);
					reject(err);
				});
			});
		},
		axiosDelete(context, payload) {
			// NEW 
			let urlParams = (window.VUE_APP_REMOTE_API_URL   || process.env.VUE_APP_REMOTE_API_URL);
			
			if(payload.domain != null && payload.id != null )
				urlParams += '/api/' + payload.domain + '/' + payload.id
			else if(payload.url != null )
				urlParams += payload.url

			return new Promise((resolve, reject) => {
				axios.delete(urlParams ,
					{
						crossDomain: true,
						responseType: 'json',
						headers: {
							'X-Auth-Token': context.getters.accessToken,
							'accept': 'application/json'
						},
					}
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					errorResponse(err);
					reject(err);
				});
			});
		},
		initFlash(context) {
			context.commit('initFlash')
		},
		setFlash(context, payload) {
			context.commit('setFlash', payload)
		},
		loading(context, payload) {
			context.commit('loading', payload)
		},
		unloading(context) {
			context.commit('unloading')
		},
		showToast(context, payload) {
			var toastOption = {
				position: 'top-center',
				// position: 'top-right',
				timeout: 2000,
				hideProgressBar: false,
				closeButton: true,
			};
			
			if(payload.type == 'success')
				toast.success(payload.message,toastOption);
			else if(payload.type == 'error')
				toast.error(payload.message, toastOption);
			else if(payload.type == 'info')
				toast.info(payload.message,toastOption);
			else if(payload.type == 'warning')
				toast.warning(payload.message,toastOption);
			else
				toast.error(payload.message,toastOption);
				// toast.error(payload.message,toastOption);
			
		},
	}
	
});
export default store